import React from "react";
import ActivityPriceDetail from "./ActivityPriceDetail";

export default function ActivityPrice({ contract, contractPriceDetails }) {
  return contractPriceDetails.map((cpd, index) => <ActivityPriceDetail contract={contract} cpd={cpd} key={cpd.id} index={index} />);
}
